import {Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Renderer2, AfterViewChecked} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpResponse, HttpHeaders } from '@angular/common/http';


// Import Quill specific types for typing content change events
// @ts-ignore
import { ContentChange} from 'ngx-quill';
// Make sure this import is correct

// Assume these services/components are defined elsewhere
import { ApifirstService } from 'src/app/service/apifirst.service';
import { FdrsClientService } from 'src/app/service/fdrs-client.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';
import { DraggablemodalComponent } from '../draggablemodal/draggablemodal.component';
import { Draggablemodal3Component } from '../draggablemodal3/draggablemodal3.component';
import { ReportAProblemPageComponent } from '../report-a-problem-page/report-a-problem-page.component';
import { ScheduleJobComponent } from '../schedule-job/schedule-job.component';
import { Draggablemodal1Component } from '../draggablemodal1/draggablemodal1.component';
import * as environmentUrl from "../../../environments/environment";
import {CheckExistingSessionComponent} from "../check-existing-session/check-existing-session.component";

interface TokenDetails {
  vin: string;
  marketCountry: string;
  dealerCode: string;
  userType: string;
  username: string;
}
/**Whats New Definition*/
interface Market {
  id3: string;
  name: string;
}

interface Message {
  id: number;
  type: string;
  text: string;
  market: string;
  language: string;
  textColor?: string;
  date: Date;
  lastEditedDate: Date;
  isNew: boolean;
  isHovered: boolean;
  isEditing: boolean;
  validationError?: string;
  createdBy?: string;
  updatedBy?: string;

  batchUuid?: string;
  editable: boolean;
  isOriginallyAllBatch?: boolean;

  isDisplayedAsBatch?: boolean;
  representativeId?: number;

  attachmentFilename?: string;
  attachmentContentType?: string;
  originalFilename?: string;
}

interface BackendMessageResponse {
  id: number;
  type: string;
  text: string | null; // <-- Backend can send null, so define it here
  market: string;
  language: string;
  textColor?: string;
  createdTime: string;
  updatedTime: string;
  createdBy?: string;
  updatedBy?: string;
  batchUuid?: string;
  editable: boolean;
  attachmentFilename?: string;
  attachmentContentType?: string;
  originalFilename?: string;
}

interface WhatsNewMessageRequest {
  type: string;
  text: string;
  market: string;
  language: string;
  textColor: string;
  createdBy: string;
  updatedBy: string;
  attachmentFilename?: string;
  attachmentContentType?: string;
  originalFilename?: string;
  removeAttachment?: boolean;
}

/**Whats New Definition End*/


@Component({
  selector: 'app-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.scss', './startup-whatsnew.scss', './startup-whatsnew2.scss','./startup-whatsnew3.scss', './startup-whatsnew4.scss', './startup-gtac.scss']
})
export class StartupComponent implements OnInit, AfterViewChecked { // <--- Implement AfterViewChecked here
  public showTitle: boolean = true;
  public userId: any
  public Vinnumber: string = '';
  public tokenDetails: any
  public userType: any;
  public showSBDAdminTab: any = false;
  isFDRSConnected: boolean = false;
  public isUserAdmin: boolean = false;
  public isDisableStartDiagnosticBtn: boolean = true;
  public progressbar: boolean = false;
  public isNetwork = false;
  public country: string = '';
  public lang: string = '';
  public isShowTestProgressBlock: boolean = false;
  public isShowOverrideBlock: boolean = false;
  public isNetworkTestNeeded: boolean = false;
  public isShowReRunBlock: boolean = false;
  public isDisableNwHeader: boolean = false;
  public isNetworkTestError: boolean = false;
  public retryNetworkTestCount: number = 0;
  public isSessionCreated: boolean = false;
  public isNWTestFailedMultiple: boolean = false;
  public isNWTestFailedAdmin: boolean = false;
  public isNetworkFailure: boolean = false;
  public resume: boolean = false;
  public isShowNavBar: boolean = false;
  public isFromRepairComplete: boolean = false;
  reRunNetworkTestArray: any = [];
  maxFailureTimes: number = 0;
  userTypeId: any;
  market: any;
  username: any
  countrythree: any
  public tokenDet: any;
  public getDateFromstorage: any;
  public currentDate: any;
  public formattedDate: any;
  public storedVin: any;
  public currentVin: any;
  startDiagnosticBtnClicked: boolean = false;
  isAdminBtnClicked: boolean = false;
  isDiagnosticBtnClicked: boolean = false;
  isDTCBtnClicked: boolean = false;
  isResumeBtnClicked: boolean = false;
  isDisableResumeBtn: boolean = false;
  isDisableDTCBtn: boolean = false;
  isDisableDiagnosticBtn: boolean = false;
  isDisableAdminBtn: boolean = false;
  isDisableNetworkTestBtn: boolean = false;
  isNetworkTestBtnClicked: boolean = false;
  isRAPAvailable: boolean = false;
  networkTestErrorMsg: string = '';
  modelYear: any
  vindetails: any
  vehicle: any
  dealerCode: any
  showLoader: boolean = false;
  noOfWebSocketConnRetry: number = 0;
  networkTestState: string = 'onPageLoad';
  webSocketsubscription: Subscription = new Subscription;
  freshWebSocetSubscription: Subscription = new Subscription;
  gtacpackagesub: Subscription = new Subscription;
  gtacpackageRAP: Subscription = new Subscription;
  fdrsWebSocketConnected: boolean = true;
  isHomeBtnsCliked: boolean = false;
  isVehicleModelMissing: boolean = false;
  info:string = '';
  showMore: boolean = false;
  adjustTopBtnPostion: boolean =false;
  intialpositionString: string = '';
  isDataCollectorChecked: boolean = false;
  isShowDataCollectorCheckBox: boolean = false;
  showDataCollectorBtn: boolean = false;
  dataCollectorEvent: string = '';
  dataCollectorSessionId: string = '';
  isDataCollectorBtnClicked: boolean = false;
  showUnauthorizedAccessPage: boolean = false;
  showTempDealerBtn: boolean = false;
  isTemplateDownloaded: boolean = false;
  isTemplateCompleteChecked: boolean = false;
  private preCheckModalRef: NgbModalRef;
  edmMarkets: any = ['AL', 'AM', 'AZ', 'BA', 'BY', 'BG', 'HR', 'CY', 'EE', 'FK', 'GI', 'GE', 'GS', 'KZ', 'LV', 'LT', 'MT', 'MD', 'MK', 'CS', , 'UA', 'TR', 'SI', 'SK', 'CS']
  @ViewChild('NWTErrorInfo') NWTErrorInfo: ElementRef | undefined;
  @ViewChild('gtacRap') gtacRap: ElementRef | undefined;
  @ViewChild('VehicleModelMissing') VehicleModelMissing: ElementRef | undefined;
  @ViewChild('DTCInfo') DTCInfo: ElementRef | undefined;
  @ViewChild('gtacPreCheckTemplate') gtacPreCheckTemplate: ElementRef | undefined;
  startNWTStatus: Subscription = new Subscription;
 reasonKey="";
  /**Whats New Changes*/
  public filteredMessages: Message[] = [];
  public displayedMessages: Message[] = [];
  public selectedMarket: string = 'All';
  public selectedLanguage: string = 'English';

  public availableMarkets: Market[] = [];
  public availableLanguages: string[] = ['English', 'German', 'French', 'Italian', 'Spanish', 'Turkish'];

  selectedPeriod: any = '90';
  messageIdToDelete = 0;
  superAdmin: boolean = false;
  public newMessageText: string = '';
  newMessageHeader: string = '';
  public newMessageColor: string = '#000000';
  public isAddingNewMessage: boolean = false;
  public addValidationError: string | null = null;

  public showEditForm: boolean = false;
  public editingMessageData: WhatsNewMessageRequest | null = null;
  public currentEditingMessage: Message | null = null;
  public editValidationError: string | null = null;

  public selectedFileForAdd: File | null = null;
  public selectedFilenameForAdd: string | null = null;
  public selectedFileForEdit: File | null = null;
  public selectedFilenameForEdit: string | null = null;
  public removeExistingAttachment: boolean = false;
  public fileValidationError: string | null = null;
  browserName = '';
  isacknowledged: boolean = false;
  ptsUrl = environmentUrl.environment.ptsUrl
  isBrowserPopupOpen: boolean = false;
  shouldShowDTCInfo = false;

  public availableColors: string[] = ['#000000', '#008000', '#FF0000', '#0000FF'];
  public colorNameMap: { [hex: string]: string } = {
    '#000000': 'Black', '#008000': 'Green', '#FF0000': 'Red', '#0000FF': 'Blue',
  };

  showWhatsNew: boolean = true;
  isMessageDeleted: boolean = false;
  isMessageSaved: boolean = false;

  public europeanCountries = [
    "ALB", "AND", "ARM", "AUT", "AZE", "BLR", "BEL", "BIH", "BGR", "HRV", "CYP", "CZE", "DNK", "EST", "FLK", "FIN", "FRA", "GEO", "DEU", "GIB", "GRC", "HUN", "ISL", "IRL", "ITA", "KAZ", "LVA", "LIE", "LTU", "LUX", "MKD", "MLT", "MDA", "MCO", "MNE", "NLD", "NOR", "POL", "PRT", "ROU", "RUS", "SMR", "SRB", "SVK", "SVN", "SGS", "ESP", "SWE", "CHE", "TUR", "UKR", "GBR", "VAT"
  ];
  private europeanCountriesSet: Set<string>;

  private languageCodeMap: { [code: string]: string } = {
    'en': 'English',
    'de': 'German',
    'fr': 'French',
    'it': 'Italian',
    'es': 'Spanish',
    'tr': 'Turkish',
    'en-US': 'English',
    'de-DE': 'German',
    'fr-FR': 'French',
    'it-IT': 'Italian',
    'es-ES': 'Spanish',
    'tr-TR': 'Turkish'
  };

  languageIconMap: { [key: string]: string } = {
    'English': 'assets/images/new-icon.png', 'French': 'assets/images/new-icon-french.png',
    'Italian': 'assets/images/new-icon-italian.png', 'Spanish': 'assets/images/new-icon-spanish.png',
    'German': 'assets/images/new-icon-german.png', 'Turkish' : 'assets/images/new-icon-turkish.png'
  };

  @ViewChild('marketSelect', { static: false }) marketSelect: ElementRef | undefined;
  @ViewChild('whatsNewContainer', { static: false }) whatsNewContainer: ElementRef | undefined; // <--- This needs to be defined
  @ViewChild('deleteWhatsNew', { static: true }) deleteWhatsNew: any;

// Added ViewChild for QuillEditorComponent instances
  @ViewChild('newQuillEditor') newQuillEditorRef: any; // Type as 'any' for simpler access or 'QuillEditorComponent' if imported
  @ViewChild('editQuillEditor') editQuillEditorRef: any; // Type as 'any' for simpler access or 'QuillEditorComponent' if imported
  @ViewChild('browserPopup', { static: true }) browserPopup: any;
// Quill Editor Configuration
  public editorModules = {
    toolbar: [
      ['bold', 'italic', { 'list': 'bullet' }]
    ]
  };

  public newMessagesCharRemaining: number = 500;
  public editMessagesCharRemaining: number = 500;
  public maxUserCharacters: number = 500;
  public quillMaxLength: number = this.maxUserCharacters + 1;

  // NEW: Property to track scrollbar presence
  public whatsNewHasScrollbar: boolean = false;
  isLoadingEditorContent : boolean;
  /** Stores the original backend HTML to be loaded into the editor via dangerouslyPasteHTML.
   *  Kept separate from editingMessageData.text (which tracks live editor state) so that
   *  Angular's ngModel write path can never corrupt the list structure before it is pasted. */
  private rawEditingMessageText: string = '';
  /**Whats New Changes End*/
  constructor(private router: Router, private service: ApifirstService, private modalService: NgbModal, private fdrsClient: FdrsClientService, private rpcClientService: RpcClientService, public datePipe: DatePipe, public translate: TranslateService,
              private renderer: Renderer2, private cdr: ChangeDetectorRef) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.url;
        console.log('current URL----------------', currentUrl);
        if(currentUrl == '/unauthorizedAccess'){
          this.showUnauthorizedAccessPage = true;
        }
      }
    });
    this.europeanCountriesSet = new Set(this.europeanCountries);
  }

  ngOnInit(): void {
    const userAgent = navigator.userAgent;
    this.browserName = this.detectBrowser(userAgent);

    if (!window.opener && this.browserName !== 'Chrome') {
      this.isBrowserPopupOpen = true;
      const modalRef = this.modalService.open( this.browserPopup, {backdrop: 'static', keyboard: false});
      //report
      // Report details
      const tokenDets = this.service.tokenObj.getValue() as TokenDetails;

      // Safely get vinDetails and its properties
      const vinDetails = this.service.getVinDetailsSnapshot();
      let vehicleType = 'Unknown'; // Default value

      if (vinDetails && vinDetails.vehicleLineDescription) {
        vehicleType = vinDetails.vehicleLineDescription;
      } else {
        console.warn('vinDetails or vehicleLineDescription is missing from snapshot.');
      }

      // Use tokenDets.username directly for the initial reportdto
      // This assumes tokenDets contains the username, which it should if tokenObj is a BehaviorSubject
      const reportdto = {
        vin: tokenDets.vin,
        id: "1007",
        vehicleType: vehicleType,
        market: tokenDets.marketCountry,
        dealerCode: tokenDets.dealerCode,
        gnumber: this.browserName,
        userType: tokenDets.userType,
        username: tokenDets.username
      };

      // Ensure error handling for the service call
      this.service.reportdetails(reportdto).subscribe(
        (data) => {
          console.log('Report details sent successfully:', data);
        },
        (error) => {
          console.error('Failed to send report details:', error);
        }
      );
      modalRef.result.finally(() => {
        this.isBrowserPopupOpen = false;
        if (this.shouldShowDTCInfo) {
          this.shouldShowDTCInfo = false;
          this.modalService.open(this.DTCInfo, { size: 'md' });
        }
      });
    }
    this.service.showMoreDiagnosticHWReqText.subscribe((data: boolean)=> {
      this.showMore = data;
    })

    this.service.showDataCollectorsBtn.subscribe((data: boolean)=> {
      this.showDataCollectorBtn = data;
    })

    this.service.showTempDealerBtn.subscribe((data: boolean)=> {
      this.showTempDealerBtn = data;
    })

    this.service.showDataCollectorCheckBox.subscribe((data: boolean)=> {
      this.isShowDataCollectorCheckBox = data;
    })

    this.service.userId.subscribe((data: any) => {
      this.userId = data;
      console.log('USER ID CALLED - START UP ------------------------>',this.userId);
      localStorage.setItem('userId', this.userId);
    })

    this.service.showWhatsNew$.subscribe((value: boolean) => {
      this.showWhatsNew = value;
      this.cdr.detectChanges();
    });

    this.info = this.translate.instant('dtcClearInformation');
    localStorage.setItem("component", "fromStartup")
    this.service.rapToken.subscribe((data: any) => {
      this.tokenDet = data;
    })
    this.service.isShowRAP.subscribe((data: boolean) => {
      this.isRAPAvailable = data;
    })

    if (window.location.pathname != "/startup") {
      this.isShowNavBar = true;
    }

    this.service.showSBDAdminTab.subscribe((data: any) => {
      this.showSBDAdminTab = data
    })

    this.service.isHomeNWTBtnCilcked.subscribe((data: boolean) => {
      this.isNetworkTestBtnClicked = data;
    })

    this.service.tokenObj.subscribe((data: {}) => {
      this.tokenDetails = data
      this.Vinnumber = this.tokenDetails.vin
      this.currentVin = this.tokenDetails.vin
      this.userType = this.tokenDetails.userType
      this.country = this.tokenDetails.country;
      this.lang = this.tokenDetails.language;
      this.market = this.tokenDetails.marketCountry
      this.username = this.tokenDetails.username
      this.countrythree = this.tokenDetails.countryThree
      this.dealerCode = this.tokenDetails.dealerCode
      if (Object.keys(data).length !== 0) {
        if (this.userType == 'FORD_INTERNAL') {
          this.userTypeId = 1
        } else if (this.userType == 'PTS_DEALER') {
          this.userTypeId = 3;
        } else if (this.userType == 'PTS_AFTERMARKET') {
          this.userTypeId = 2;
        }
        const vin = {
          "vin": this.tokenDetails.vin,
          "paCode": this.tokenDetails.dealerCode,
          "country": this.tokenDetails.country,
          "language": this.tokenDetails.language
        }
        this.getNetworkTestFailureAttempts();

        this.service.isNetworkTestNeeded(this.Vinnumber,this.userTypeId,this.countrythree).subscribe((data: { status: boolean; adhocParameter: { value: string; }; }) => {
          this.isNetworkTestNeeded = data.status;
          if (!this.isNetworkTestNeeded) {
            this.isDisableStartDiagnosticBtn = false;
          }
          if(this.isNetworkTestNeeded && !this.isUserAdmin && data.adhocParameter.value == 'true') {
            if (this.isBrowserPopupOpen) {
              this.shouldShowDTCInfo = true;
            } else {
              this.modalService.open(this.DTCInfo, {size: 'md'});
            }
          }
        })
      }

      /**Whats New Role allocation starts*/
      let getselectuserdetails =
        {
          "username": this.username,
          "userType": this.userTypeId
        }
      this.service.getUserRoleDetails(getselectuserdetails).subscribe(
        (datagetUserRoleDetails: { selectedUserRoles:string[]; }) => {
          this.service.setUserRoles(datagetUserRoleDetails.selectedUserRoles);
          if(datagetUserRoleDetails.selectedUserRoles.includes('SBDO_SUPER_ADMIN')){
            this.superAdmin = true;
          } else {
            this.superAdmin = false;
          }
          this.updateNewMessageCharCount();
          this.updateEditMessageCharCount();
          this.initializeMessages();

          // 2. Apply dealer-specific market restriction if userTypeId is 3
          if (this.userTypeId === 3) { // PTS_DEALER
            const dealerMarketCode = this.market; // The market code from tokenDetails
            if (dealerMarketCode) {
              let dealerMarket = this.availableMarkets.find(m => m.id3.toLowerCase() === dealerMarketCode.toLowerCase());
              if (!dealerMarket) {
                // If the dealer's specific market is not found in the initial European list,
                // create a new Market object for it.
                dealerMarket = { id3: dealerMarketCode, name: this.getCountryNameFromCode(dealerMarketCode) };
              }
              this.selectedMarket = dealerMarket.id3; // Set the selected market to the dealer's market
              this.availableMarkets = [dealerMarket]; // Restrict the available markets to just this one
            }
          }
          this.filterMessages(); // Re-filter messages based on the final market selection
          this.cdr.detectChanges(); // Ensure UI updates are reflected
        })
      /**Whats New Role allocation end*/


    })

    this.service.isFromRepairComplete.subscribe((data: boolean) => {
      this.isFromRepairComplete = data;
    })

    this.service.showSBDAdminTab.subscribe((data: boolean) => {
      this.isUserAdmin = data;
    })

    this.service.fromResume.subscribe((data: any) => this.resume = data)

    this.webSocketsubscription = this.service.getWebsocketStatusonStartUpComp.subscribe((data: string) => {
      if (data == 'true') {
        this.fdrsWebSocketConnected = true;
        this.showLoader = false;
        this.isFDRSConnected = true;
        switch (this.networkTestState) {
          case "startNWT":
            this.showStartNetworkTestBlock();
            break;
          case "reRunNWT":
            this.showReRunNetworkTestBlock();
            break;
          case "retryNWT":
            this.showRetryNetworkTestBlock();
            break;
          case "onPageLoad":
            this.ShowNetworkTestBlock();
            break;
        }

      } else if (data == 'false') {
        console.log("<--- Websocket: False---->")
        this.service.isShowFDRSLoader.next(false);
        this.fdrsWebSocketConnected = false;
        this.showLoader = false;
        this.isFDRSConnected = false;
        this.noOfWebSocketConnRetry = this.noOfWebSocketConnRetry + 1;
        if (this.noOfWebSocketConnRetry < 2) {
          this.showNetworkTestErrorBlock();
        }
      }
    })

    this.freshWebSocetSubscription = this.service.freshWebSocketConnStatusonStartUpComp.subscribe((data: string) => {
      if (data == 'true') {
        this.fdrsWebSocketConnected = true;
        this.showLoader = false;
        this.isFDRSConnected = true;
        switch (this.networkTestState) {
          case "startNWT":
            this.showStartNetworkTestBlock();
            break;
          case "reRunNWT":
            this.showReRunNetworkTestBlock();
            break;
          case "retryNWT":
            this.showRetryNetworkTestBlock();
            break;
          case "onPageLoad":
            this.ShowNetworkTestBlock();
            break;
        }
      } else if (data == 'false') {
        console.log("<---fresh Websocket: False---->")
        this.service.isShowFDRSLoader.next(false);
        if (!this.startDiagnosticBtnClicked) {
          this.showLoader = false;
          this.fdrsWebSocketConnected = false;
        }
        this.isFDRSConnected = false;
      }
    });

    this.service.isFDRSConnection.subscribe((data: boolean) => {
      this.isFDRSConnected = data;
      if (!data) {
        this.isDisableStartDiagnosticBtn = false;
      }
    })

    this.startNWTStatus = this.service.isFDRSNetworkTest$.subscribe((data: any) => {
      if (!this.resume && !this.isFromRepairComplete && !this.isNetworkTestBtnClicked) {
        this.isDataCollectorChecked = false;
        if (data.status) {
          localStorage.setItem('DCSessionId', '');
          this.isNetwork = data.status;
          setTimeout(() => {
            this.isShowTestProgressBlock = false;
            this.isShowReRunBlock = true;
            this.isDisableStartDiagnosticBtn = false;
            this.isDisableResumeBtn = false;
            this.isDisableDiagnosticBtn = false;
            this.isDisableAdminBtn = false;
            this.isDisableNetworkTestBtn = false;
            this.isDisableDTCBtn = false;
            this.showWhatsNew = true;
          }, 5000);

          let sessionId:any = '';
          if(this.dataCollectorEvent == 'FULL') {
            sessionId = this.dataCollectorSessionId;
          } else {
            sessionId = localStorage.getItem("sessionID")
          }

          let obj = {
            "sessionID": sessionId,
            "vin": this.Vinnumber,
            "userType":this.userType,
            "dcCollectorVin": this.isShowDataCollectorCheckBox,
            "nwtStatus": "success"
          }
          this.service.postNetworkTest(obj).subscribe((data) => {
          })

          this.service.captureEvisDataDetails(this.Vinnumber, this.lang, this.country,sessionId, this.userId).subscribe((data) => {
            this.dataCollectorEvent = '';
          },(error:any)=> {
            this.dataCollectorEvent = '';
          })
          console.log('network test finished')
        } else {
          // Network test error
          let sessionId:any = '';
          if(this.dataCollectorEvent == 'FULL') {
            sessionId = this.dataCollectorSessionId;
          } else {
            sessionId = localStorage.getItem("sessionID")
          }

          let obj = {
            "sessionID": sessionId,
            "vin": this.Vinnumber,
            "userType":this.userType,
            "dcCollectorVin": this.isShowDataCollectorCheckBox,
            "nwtStatus": "failed"
          }
          this.service.postNetworkTest(obj).subscribe((data: any) => {
          })
          this.modalService.open(this.NWTErrorInfo, { size: 'lg' });
          this.networkTestErrorMsg = data.reason;
          this.isNetworkFailure = true;
          console.log("data reason",data.reason)
          if (data.reason == "Unable to communicate to the vehicle. Make sure the Ignition is turned ON and that the DLC and USB connections are OK. If Ok then go to the Menu-Device Manager and verify you are connecting to the appropriate VCI Device. ") {
            this.reasonKey = "1004";
          }
            else if(data.reason=="Unable to read vins"){
               this.reasonKey="1003"
            }
           else if(data.reason=="Lost communication to vehicle"){
             this.reasonKey="1005"
           }
           else if(data.reason=="VIN Mismatch"){
             this.reasonKey="1006"
           }
           else{
             this.reasonKey=data.reason;
           }

        const vinDetails = this.service.getVinDetailsSnapshot();
      console.log("vinDetails",vinDetails)
          this.isNetworkFailure = true;
          let reportdto={
            "vin": this.Vinnumber,
            "id": this.reasonKey,
            "vehicleType":vinDetails?.vehicleLineDescription,
            "market": this.market,
            "dealerCode":this.dealerCode,
            "gnumber":"not applicable"
          }
          this.service.reportdetails(reportdto).subscribe((data:any)=>{});

          if (this.isUserAdmin) {
            setTimeout(() => {
              console.log("Admin fail called");
              this.isShowOverrideBlock = false;
              this.isShowTestProgressBlock = false;
              this.isShowReRunBlock = false;
              this.isNWTestFailedMultiple = false;
              this.isNetworkTestError = false;
              this.isNWTestFailedAdmin = true;
              this.isDisableStartDiagnosticBtn = false;
              this.isDisableResumeBtn = false;
              this.isDisableDiagnosticBtn = false;
              this.isDisableAdminBtn = false;
              this.isDisableNetworkTestBtn = false;
              this.isDisableDTCBtn = false;
              this.showWhatsNew = true;
            }, 5000);
          } else {
            console.log("max failure Case:", this.maxFailureTimes)
            this.retryNetworkTestCount = this.retryNetworkTestCount + 1;
            if (this.retryNetworkTestCount >= this.maxFailureTimes) {
              setTimeout(() => {
                this.isShowOverrideBlock = false;
                this.isShowTestProgressBlock = false;
                this.isShowReRunBlock = false;
                this.isNWTestFailedMultiple = true;
                this.isNetworkTestError = false;
                this.isNWTestFailedAdmin = false;
                this.isDisableStartDiagnosticBtn = false;
                this.isDisableResumeBtn = false;
                this.isDisableDiagnosticBtn = false;
                this.isDisableAdminBtn = false;
                this.isDisableNetworkTestBtn = false;
                this.isDisableDTCBtn = false;
                this.showWhatsNew = true;
              }, 5000)
            } else {
              setTimeout(() => {
                this.isNetwork = data;
                this.progressbar = false;
                this.isNetworkTestError = true;
                this.isShowTestProgressBlock = false;
                this.isDisableStartDiagnosticBtn = false;
                this.isDisableResumeBtn = false;
                this.isDisableDTCBtn = false;
                this.isDisableDiagnosticBtn = false;
                this.isDisableAdminBtn = false;
                this.isDisableNetworkTestBtn = false;
                this.showWhatsNew = true;
              }, 5000)
            }
          }
        }
      }
    })

    this.service.isSessionCreated.subscribe((data: boolean) => {
      this.isSessionCreated = data;
    })

    this.service.isNWTInProgress.subscribe((data: any) => {
      if (data == 'NWTRunning') {
        this.isDisableStartDiagnosticBtn = true;
        this.isDisableResumeBtn = true;
        this.isDisableDiagnosticBtn = true;
        this.isDisableAdminBtn = true;
        this.isDisableNetworkTestBtn = true;
        this.isDisableDTCBtn = true;
        this.showWhatsNew = true;
        this.service.setShowWhatsNew(true);
      } else if (data == 'NWTNotRunning') {
        this.isDisableStartDiagnosticBtn = false;
        this.isDisableResumeBtn = false;
        this.isDisableDiagnosticBtn = false;
        this.isDisableAdminBtn = false;
        this.isDisableNetworkTestBtn = false;
        this.isDisableDTCBtn = false;
        this.showWhatsNew = true;
        this.service.setShowWhatsNew(true);
      } else if (data == 'NWTOverride') {
        this.isDisableStartDiagnosticBtn = false;
        this.isDisableResumeBtn = false;
        this.isDisableDiagnosticBtn = false;
        this.isDisableAdminBtn = false;
        this.isDisableNetworkTestBtn = false;
        this.isDisableDTCBtn = false;
        this.showWhatsNew = true;
        this.service.setShowWhatsNew(true);
      }
    })
  }

  // NEW: Lifecycle hook to check scrollbar status after every change detection cycle
  ngAfterViewChecked(): void {
    setTimeout(() => {
      this.checkWhatsNewScrollbar()
    })
  }

  // NEW: Method to check if the whatsNewContainer has a scrollbar
  checkWhatsNewScrollbar(): void {
    if (this.whatsNewContainer && this.whatsNewContainer.nativeElement) {
      const element = this.whatsNewContainer.nativeElement.querySelector('.whats-new-messages'); // Target the scrollable content area
      if (element) {
        const hasScroll = element.scrollHeight > element.clientHeight;
        this.service.setHasScrollbar(hasScroll);

        if (this.whatsNewHasScrollbar !== hasScroll) {
          console.log('Scrollbar status changed:', hasScroll); // Add a log for debugging
          this.whatsNewHasScrollbar = hasScroll;
          this.cdr.detectChanges(); // Trigger change detection if value changes
        }
      } else {
        // console.log('whats-new-messages element not found inside whatsNewContainer'); // Debugging log
      }
    }
    else {
      // console.log('whatsNewContainer not found'); // Debugging log
    }
  }

  getNetworkTestFailureAttempts() {
    this.service.getReRunNetworkTestConfiguration(this.userTypeId, this.market).subscribe((data: any) => {
      console.log("rerunconfig:", data);
      this.maxFailureTimes = data;
    })
  }

  /** start diagnosis button**/
  onButtonGroupClick($event: any) {
    this.showTitle = false;
    let clickedElement = $event.target || $event.srcElement;
    if (clickedElement.nodeName === "BUTTON") {
      let isCertainButtonAlreadyActive = clickedElement.parentElement.querySelector(".active");
      if (isCertainButtonAlreadyActive) {
        isCertainButtonAlreadyActive.classList.remove("active");
      }
      else {
        clickedElement.className += " active";
      }
    }
  }
  fileToUpload: any
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  onNewMessageContentChanged(event: ContentChange): void {
    const editor = event.editor;
    const currentText = editor.getText(); // Get plain text directly from editor
    let userTypedChars = currentText.length - 1; // Quill's getText() includes trailing newline.

    // Truncate if content exceeds maxUserCharacters (e.g., due to paste)
    if (userTypedChars > this.maxUserCharacters) {
      editor.deleteText(this.maxUserCharacters, userTypedChars - this.maxUserCharacters);
      userTypedChars = this.maxUserCharacters; // Update count after truncation
    }

    this.newMessagesCharRemaining = this.maxUserCharacters - userTypedChars;

    // Ensure counter doesn't go negative visually
    if (this.newMessagesCharRemaining < 0) {
      this.newMessagesCharRemaining = 0;
    }

    this.newMessageText = editor.root.innerHTML; // Get HTML content directly from editor root
  }

  onEditMessageContentChanged(event: ContentChange): void {
    const editor = event.editor;
    const currentText = editor.getText(); // Get plain text directly from editor
    let userTypedChars = currentText.length - 1;

    // Truncate if content exceeds maxUserCharacters (e.g., due to paste)
    if (userTypedChars > this.maxUserCharacters) {
      editor.deleteText(this.maxUserCharacters, userTypedChars - this.maxUserCharacters);
      userTypedChars = this.maxUserCharacters; // Update count after truncation
    }

    this.editMessagesCharRemaining = this.maxUserCharacters - userTypedChars;

    // Ensure counter doesn't go negative visually
    if (this.editMessagesCharRemaining < 0) {
      this.editMessagesCharRemaining = 0;
    }

    // CRITICAL FIX: Only update editingMessageData.text if event.html is a valid string
    // and if we are not in the middle of a programmatic load.
    // If event.html is null/undefined (which can happen during intermediate Quill operations),
    // or if the source is 'api' (programmatic change), do not update the ngModel property directly,
    // as it might be an intermediate state or being handled by _loadContentIntoEditor.
    if (this.editingMessageData) {
      // Skip updating the model during programmatic content loading (e.g. when opening edit mode).
      // dangerouslyPasteHTML fires content-change events with source='api'; if we allow those
      // to write back to editingMessageData.text we get a feedback loop that re-injects the
      // original HTML (with <span class="ql-ui">) and prevents bullet points from rendering.
      if (this.isLoadingEditorContent) {
        return;
      }

      const newHtml = (event.html !== null && event.html !== undefined) ? event.html : editor.root.innerHTML;

      // Only update if the HTML is not effectively empty, unless it's a user clearing content.
      if (newHtml && newHtml.trim() !== '<p><br></p>' && newHtml.trim() !== '') {
        this.editingMessageData.text = newHtml;
      } else if (event.source === 'user' && (newHtml === null || newHtml.trim() === '' || newHtml.trim() === '<p><br></p>')) {
        // If a user explicitly clears the editor, ensure the model reflects that.
        this.editingMessageData.text = '';
      }
    }

    console.log('onEditMessageContentChanged ::: ', event); // Keep for debugging
  }

  // Removed getPlainTextLength as it's no longer needed due to using editor.getText()

  // Modified updateCharCount methods to only initialize display
  updateNewMessageCharCount(): void {
    // This method is called to initialize the display.
    // The actual live counting happens in onNewMessageContentChanged.
    // If newMessageText is populated on load, calculate its length.
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.newMessageText;
    const initialLength = tempDiv.textContent?.length || 0;
    this.newMessagesCharRemaining = this.maxUserCharacters - initialLength;
    if (this.newMessagesCharRemaining < 0) {
      this.newMessagesCharRemaining = 0;
    }
  }

  updateEditMessageCharCount(): void {
    // This method is called to initialize the display.
    // The actual live counting happens in onEditMessageContentChanged.
    // If editingMessageData.text is populated on load, calculate its length.
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.editingMessageData?.text || '';
    const initialLength = tempDiv.textContent?.length || 0;
    this.editMessagesCharRemaining = this.maxUserCharacters - initialLength;
    if (this.editMessagesCharRemaining < 0) {
      this.editMessagesCharRemaining = 0;
    }
  }


  openGtacRAPConfirmationPopUp() {
    this.service.showMoreDiagnosticHWReqText.next(false);
    this.modalService.open(this.gtacRap, { size: '' });
  }

  reportAProblemPopup() {
    this.rpcClientService.checkFDRSConnectionStatustoDownloadLogs();
    this.gtacpackageRAP = this.service.fdrsConnectionStatus.subscribe((data: any)=> {
      console.log('FDRS Connection Status----------------', data);
      if(data) {
        var jsonToSend = {
          "method": "create_gtac_package"
        };

        this.rpcClientService.sendMessageToFDT("CREATE_GTAC_PACKAGE", jsonToSend, '');
        this.gtacpackageRAP.unsubscribe();
        this.gtacpackageRAP = this.service.fdrsConnectionStatus.subscribe();
      }
    })
    const modalRef = this.modalService.open(ReportAProblemPageComponent, {
      windowClass: "myCustomModalClass",
      backdrop: 'static'
    });
  }
  /** to open pop up **/
  openModal() {
    this.service.showMoreDiagnosticHWReqText.next(false);
    this.rpcClientService.HideFDRSIconIfNotConnected();
    this.isDisableStartDiagnosticBtn = true;
    this.fdrsWebSocketConnected = true;
    this.startDiagnosticBtnClicked = true;
    this.isShowReRunBlock = false;
    this.isDisableNwHeader = true;
    this.isNWTestFailedAdmin = false;
    this.isNWTestFailedMultiple = false;
    this.isNetworkTestError = false;
    this.service.userId.subscribe((data: any) => {
      this.userId = data
    })
    const req = {
      "userId": this.userId,
      "sessionSource": "gfdrs",
      "vin": this.Vinnumber
    }
    var vehicleModalMissing = localStorage.getItem('isVehileModelMissing') == 'true' ? true : false
    if (this.isSessionCreated) { //
      this.service.createSession(req).subscribe((data: any) => {
        localStorage.setItem("newSessionID", data)
        this.service.fromResume.next(false);
        this.service.fromCapture.next(false)
        this.service.navigateSymptom.next('')
        this.service.isSessionCreated.next(true);
        this.setSystemShapShotDetails();
        this.getCustomerConsent();
        localStorage.setItem('isVehileModelMissing', 'false');
      }, (error: { status: number; }) => {
        if (error.status == 404) {
          localStorage.setItem('isVehileModelMissing', 'true');
          const vinDetails = this.service.getVinDetailsSnapshot(); // null-safe
          let reportdto={
            "vin": this.tokenDetails.vin,
            "id": "1002",
            "vehicleType":vinDetails?.vehicleLineDescription,
            "market": this.tokenDetails.marketCountry,
            "dealerCode":this.tokenDetails.dealerCode,
            "gnumber":"not applicable"
          }
          this.service.reportdetails(reportdto).subscribe((data: any)=>{});

        }
      })
    }
    if (!this.isSessionCreated && !vehicleModalMissing) {
      this.getCustomerConsent();
    } else if (vehicleModalMissing) {
      this.service.createSession(req).subscribe((data: any) => {
        localStorage.setItem("newSessionID", data)
        this.service.fromResume.next(false);
        this.service.fromCapture.next(false)
        this.service.navigateSymptom.next('')
        this.service.isSessionCreated.next(true);
        this.getCustomerConsent();
        localStorage.setItem('isVehileModelMissing', 'false');
        this.setSystemShapShotDetails();
      }, (error: { status: number; }) => {
        if (error.status == 404) {
          this.isDisableStartDiagnosticBtn = false;
          localStorage.setItem('isVehileModelMissing', 'true');
          this.modalService.open(this.VehicleModelMissing, { size: 'md' });
          const vinDetails = this.service.getVinDetailsSnapshot(); // null-safe
          let reportdto={
            "vin": this.tokenDetails.vin,
            "id": "1002",
            "vehicleType":vinDetails?.vehicleLineDescription,
            "market": this.tokenDetails.marketCountry,
            "dealerCode":this.tokenDetails.dealerCode,
            "gnumber":"not applicable"
          }
          this.service.reportdetails(reportdto).subscribe((data: any)=>{});

        }
      })
    }
  }

  setSystemShapShotDetails() {
    let fdrsDetails: any = JSON.parse(localStorage.getItem("systemSnapshot") || '{}');
    var req: any;
    if (fdrsDetails.fdrsVersion == 'unknown') {
      req = {
        "sessionid": localStorage.getItem("newSessionID"),
        "fdrsVersion": "unknown",
        "javaVersion": "unknown",
        "firmwareVersioninVCM": "unknown",
        "firmwareVersioninVMM": "unknown",
        "osversion": "unknown",
        "memoryinfo": "unknown",
        "osname": "unknown",
        "cpuinfo": "unknown",
        "deviceserialnumber": "unknown"
      }
    } else {
      req = {
        "sessionid": localStorage.getItem("newSessionID"),
        "fdrsVersion": fdrsDetails.fdrsVersion,
        "javaVersion": fdrsDetails.javaVersion,
        "firmwareVersioninVCM": fdrsDetails.vcmVersion,
        "firmwareVersioninVMM": fdrsDetails.vmmVersion,
        "osversion":fdrsDetails.operatingSystemVersion,
        "memoryinfo":fdrsDetails.memoryInfo,
        "osname":fdrsDetails.operatingSystemName,
        "cpuinfo":fdrsDetails.cpuInfo,
        "deviceserialnumber":fdrsDetails.deviceSerialNumber
      }
    }
    localStorage.setItem("systemSnapshot", JSON.stringify(req));
    this.service.setSystemSnapShotDetails(req).subscribe((data: any) => {
      console.log('----updated system snapshot with value unknown-------', data);
    })
  }

  getCustomerConsent() {
    if (this.isFDRSConnected) {
      const payload = {
        vin: this.Vinnumber,
         };

      // Check Session API First
      this.service.checkExistingMobileSession(payload).subscribe((response: any) => {
        if (response && response.hasExistingSession === true &&response.sessionCount>0) {
          this.service.existingSessionData.next(response);
          const modalRef = this.modalService.open(CheckExistingSessionComponent, { backdrop: 'static' });

          modalRef.result.then((result) => {
            if (result === 'START_NEW') {

              this.storedVin = localStorage.getItem('VINnumber');
              this.getDateFromstorage = localStorage.getItem("setcustomerConcentDate");
              this.currentDate = new Date();
              this.formattedDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd hh:mm')
              var d1 = new Date(this.getDateFromstorage)
              var d2 = new Date(this.formattedDate)
              var Time = (d2.getTime() - d1.getTime())
              var Days = Math.round(Time / (1000 * 3600 * 24))

              if (Days > 0) {
                const modalRef3 = this.modalService.open(Draggablemodal3Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
                modalRef3.result.then(res => { this.isDisableStartDiagnosticBtn = false; }, reason => { });
              } else {
                var arr = this.storedVin ? this.storedVin.split(",") : [];
                if (arr.includes(this.currentVin)) {
                  const modalRef1 = this.modalService.open(Draggablemodal1Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
                  modalRef1.result.then(res => { this.isDisableStartDiagnosticBtn = false; }, reason => { })
                } else {
                  const modalRef3 = this.modalService.open(Draggablemodal3Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
                  modalRef3.result.then(res => { this.isDisableStartDiagnosticBtn = false; }, reason => { });
                }
              }

            }
          }, () => {});
        } else {
          // No session found, run original logic directly
          this.storedVin = localStorage.getItem('VINnumber');
          this.getDateFromstorage = localStorage.getItem("setcustomerConcentDate");
          this.currentDate = new Date();
          this.formattedDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd hh:mm')
          var d1 = new Date(this.getDateFromstorage)
          var d2 = new Date(this.formattedDate)
          var Time = (d2.getTime() - d1.getTime())
          var Days = Math.round(Time / (1000 * 3600 * 24))

          if (Days > 0) {
            const modalRef3 = this.modalService.open(Draggablemodal3Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
            modalRef3.result.then(res => { this.isDisableStartDiagnosticBtn = false; }, reason => { });
          } else {
            var arr = this.storedVin ? this.storedVin.split(",") : [];
            if (arr.includes(this.currentVin)) {
              const modalRef1 = this.modalService.open(Draggablemodal1Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
              modalRef1.result.then(res => { this.isDisableStartDiagnosticBtn = false; }, reason => { })
            } else {
              const modalRef3 = this.modalService.open(Draggablemodal3Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
              modalRef3.result.then(res => { this.isDisableStartDiagnosticBtn = false; }, reason => { });
            }
          }
        }
      }, (error) => {
        // API Error fallback
        this.isDisableStartDiagnosticBtn = false;
      });

    } else {
      // FDRS NOT CONNECTED - Show DraggablemodalComponent first
      const modalRef = this.modalService.open(DraggablemodalComponent, {
        windowClass: "myCustomModalClass",
        backdrop: 'static'
      });
      modalRef.result.then(
        (        result: any) => {
          console.log(result);
          this.isDisableStartDiagnosticBtn = false;
        },
        (        reason: any) => { }
      );
    }
    if (!this.isSessionCreated) {
      this.service.isSessionCreated.next(true);
    }

  }

  retryFDRSConnection() {
    this.showWhatsNew = true;
    this.service.setShowWhatsNew(true);
    this.showLoader = true;
    this.noOfWebSocketConnRetry = 0;
    if (localStorage.getItem("connectionState") == '1') {
      setTimeout(() => {
        this.rpcClientService.checkFDRSConnectionStatus();
      }, 1000)

    } else if (localStorage.getItem("connectionState") != '1') {
      this.fdrsClient.initFdrsClient("startup")
    }
  }

  overrideBtnClicked() {
    localStorage.setItem('DCSessionId', '');
    this.isDisableStartDiagnosticBtn = false;
    this.isDisableResumeBtn = false;
    this.isDisableDiagnosticBtn = false;
    this.isDisableAdminBtn = false;
    this.isDisableNetworkTestBtn = false;
    this.isDisableDTCBtn = false;
    this.isShowOverrideBlock = false;
    this.isDisableNwHeader = true;
    this.isNWTestFailedAdmin = false;
    this.isNWTestFailedMultiple = false;
    this.service.setShowWhatsNew(false);
    // this.service.isNetworkTestCompletedFromResume.next(true);
    let obj = {
      "sessionID": localStorage.getItem("sessionID"),
      "vin": this.Vinnumber,
      "userType":this.userType,
      "dcCollectorVin": this.isShowDataCollectorCheckBox,
      "nwtStatus": "overridden"
    }
    this.service.postNetworkTest(obj).subscribe((data) => {
    })
  }

  startNetworkTest() {
    this.networkTestState = "startNWT";
    this.showWhatsNew = true;
    this.service.setShowWhatsNew(true);
    if(this.dataCollectorEvent == 'FULL') {
      const req = {
        "userId": this.userId,
        "sessionSource": "gfdrs",
        "vin": this.Vinnumber
      }
      this.service.createSession(req).subscribe((data: any) => {
        this.dataCollectorSessionId = data;
        localStorage.setItem('DCSessionId', data);
        console.log('Data Collector Session ID:-------------------->', data);
      });
    }
    this.retryFDRSConnection();
  }

  showStartNetworkTestBlock() {
    this.isDisableStartDiagnosticBtn = true;
    this.isDisableResumeBtn = true;
    this.isDisableDiagnosticBtn = true;
    this.isDisableAdminBtn = true;
    this.isDisableNetworkTestBtn = true;
    this.isDisableDTCBtn = true;
    this.progressbar = true;
    this.isShowOverrideBlock = false;
    this.isShowTestProgressBlock = true;
    this.showWhatsNew = true;
    this.service.setShowWhatsNew(true)
    this.rpcClientService.runNetworkTest("", "");
  }

  reRunNetworkTest() {
    console.log('DC RE-RUN N/W TEST------------------>', this.dataCollectorEvent);
    this.showWhatsNew = true;
    this.service.setShowWhatsNew(true)
    this.networkTestState = "reRunNWT";
    if(this.dataCollectorEvent == 'FULL') {
      const req = {
        "userId": this.userId,
        "sessionSource": "gfdrs",
        "vin": this.Vinnumber
      }
      this.service.createSession(req).subscribe((data: any) => {
        this.dataCollectorSessionId = data;
        localStorage.setItem('DCSessionId', data);
        console.log('Data Collector Session ID:-------------------->', data);
        this.retryFDRSConnection();
      },(error : any)=> {
        console.log('Error while creating a session in Data collector mode:', error);
      });
    } else {
      this.retryFDRSConnection();
    }

  }

  showReRunNetworkTestBlock() {
    this.isNetworkFailure = false;
    this.isDisableStartDiagnosticBtn = true;
    this.isDisableResumeBtn = true;
    this.isDisableDiagnosticBtn = true;
    this.isDisableAdminBtn = true;
    this.isDisableNetworkTestBtn = true;
    this.isDisableDTCBtn = true;
    this.progressbar = true;
    this.isNetwork = false;
    this.isShowTestProgressBlock = true;
    this.isNetworkTestNeeded = true;
    this.isShowReRunBlock = false;
    this.showWhatsNew = true;
    this.service.setShowWhatsNew(true)
    this.rpcClientService.runNetworkTest("", "");
  }

  retryNetworkTest() {
    this.networkTestState = 'retryNWT';
    this.showWhatsNew = true;
    this.service.setShowWhatsNew(true);
    this.retryFDRSConnection();
  }

  showRetryNetworkTestBlock() {
    this.isNetworkFailure = false;
    this.isDisableStartDiagnosticBtn = true;
    this.isDisableResumeBtn = true;
    this.isDisableDiagnosticBtn = true;
    this.isDisableAdminBtn = true;
    this.isDisableNetworkTestBtn = true;
    this.isDisableDTCBtn = true;
    this.progressbar = true;
    this.isNetwork = false;
    this.isShowTestProgressBlock = true;
    this.isNetworkTestNeeded = true;
    this.isShowReRunBlock = false;
    this.isNetworkTestError = false;
    this.isNWTestFailedAdmin = false;
    this.isNWTestFailedMultiple = false;
    this.service.setShowWhatsNew(true);
    this.rpcClientService.runNetworkTest("", "");
  }

  ShowNetworkTestBlock() {
    if (!this.isAdminBtnClicked && !this.isDiagnosticBtnClicked && !this.isResumeBtnClicked && !this.startDiagnosticBtnClicked && !this.isDTCBtnClicked && !this.isDataCollectorBtnClicked) {
      if (this.isNetworkTestNeeded && !this.isUserAdmin && this.isFDRSConnected) {
        this.startNetworkTest();
      }
      if (this.isNetworkTestNeeded && this.isUserAdmin && this.isFDRSConnected) {
        this.isShowOverrideBlock = true;
        this.isDisableStartDiagnosticBtn = true;
        this.showWhatsNew = true;
        this.service.setShowWhatsNew(true);
      }
      if (!this.isNetworkTestNeeded) {
        this.isShowReRunBlock = true;
        this.showWhatsNew = true;
        this.service.setShowWhatsNew(true);
      }
    }
  }

  dataCollectorBtnClick() {
    this.isDataCollectorBtnClicked = true;
    this.service.setShowWhatsNew(false)
  }

  showNetworkTestErrorBlock() {
    this.showLoader = false;
    this.fdrsWebSocketConnected = false;
    this.rpcClientService.checkWebSocketConnectionStatus();
  }
  // set to identify which component is selected- used in close-cancel-diagnostic components
  networkTestBtnClick() {
    this.showWhatsNew = true;
    this.service.setShowWhatsNew(true);
    this.service.showMoreDiagnosticHWReqText.next(false);
    this.isVehicleModelMissing = localStorage.getItem('isVehileModelMissing') == 'true' ? true : false;
    console.log('------------VM MISSING-----------', this.isVehicleModelMissing);
    if (this.isVehicleModelMissing) {
      this.modalService.open(this.VehicleModelMissing, { size: 'md' });
      const vinDetails = this.service.getVinDetailsSnapshot(); // null-safe
      let reportdto={
        "vin": this.tokenDetails.vin,
        "id": "1002",
        "vehicleType":vinDetails?.vehicleLineDescription,
        "market": this.tokenDetails.marketCountry,
        "dealerCode":this.tokenDetails.dealerCode,
        "gnumber":"not applicable"
      }
      this.service.reportdetails(reportdto).subscribe((data)=>{});
    } else {
      this.router.navigate(['/closeCanceldiagnosis']);
    }
    localStorage.setItem("component", "fromNetworkTest");
  }

  hideNetworkTestBlock() {
    this.rpcClientService.HideFDRSIconIfNotConnected();
    this.isDisableStartDiagnosticBtn = false;
    this.isShowReRunBlock = false;
    this.isDisableNwHeader = true;
    this.isShowOverrideBlock = false;
    this.isNWTestFailedAdmin = false;
    this.isNWTestFailedMultiple = false;
    this.isNetworkTestError = false;
    this.fdrsWebSocketConnected = true;
    this.isHomeBtnsCliked = true; // BTN NAMES: RESUME, DIANGNOSTIC,ADMIN,NETWORK
    this.showWhatsNew = true;
    this.service.setShowWhatsNew(true)
    localStorage.setItem("lastVisitedScreen", "")
  }

  adminBtnClick() {
    this.isAdminBtnClicked = true;
    this.service.showMoreDiagnosticHWReqText.next(false);
  }

  diagnosticBtnClick() {
    this.service.showMoreDiagnosticHWReqText.next(false);
    this.isVehicleModelMissing = localStorage.getItem('isVehileModelMissing') == 'true' ? true : false;
    console.log('------------VM MISSING-----------', this.isVehicleModelMissing);
    if (this.isVehicleModelMissing) {
      this.modalService.open(this.VehicleModelMissing, { size: 'md' });
      const vinDetails = this.service.getVinDetailsSnapshot(); // null-safe
      let reportdto={
        "vin": this.tokenDetails.vin,
        "id": "1002",
        "vehicleType":vinDetails?.vehicleLineDescription,
        "market": this.tokenDetails.marketCountry,
        "dealerCode":this.tokenDetails.dealerCode,
        "gnumber":"not applicable"
      }
      this.service.reportdetails(reportdto).subscribe((data)=>{});
    } else {
      this.router.navigate(['/displaydiagnostic']);
    }
    this.isDiagnosticBtnClicked = true;
    this.service.setShowWhatsNew(false)
  }

  DTCBtnClick() {
    this.service.setShowWhatsNew(false)
    this.service.showMoreDiagnosticHWReqText.next(false);
    this.isDTCBtnClicked = true;
    let token = localStorage.getItem("token")
    const path = '/DTCDataView' + "?vin=" + this.Vinnumber + "&userId=" + this.username + "&userType=" + this.userType + "&countryThree=" + this.countrythree + "&language=" + this.lang + "&dealerCode=" + this.dealerCode + "&token=" + token + "#nohref";
    window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
  }

  resumeBtnClick() {
    this.isResumeBtnClicked = true;
    this.service.showMoreDiagnosticHWReqText.next(false);
    this.service.setShowWhatsNew(false);
  }
  contactSubmit(content: any) {
    this.service.setShowWhatsNew(false);
    this.rpcClientService.checkFDRSConnectionStatustoDownloadLogs();
    this.gtacpackagesub = this.service.fdrsConnectionStatus.subscribe((data: any)=> {
      console.log('FDRS Connection Status----------------', data);
      if(data) {
        var jsonToSend = {
          "method": "create_gtac_package"
        };

        this.rpcClientService.sendMessageToFDT("CREATE_GTAC_PACKAGE", jsonToSend, '');
        this.gtacpackagesub.unsubscribe();
        this.gtacpackagesub = this.service.fdrsConnectionStatus.subscribe();
      }
    })
    this.service.showMoreDiagnosticHWReqText.next(false);
    if (!this.edmMarkets.includes(this.tokenDetails['country'])) {
      this.service.vindetail.subscribe((data: any) => {
        this.vindetails = data
        console.log(this.vindetails, "vindetails")
        this.modelYear = this.vindetails.modelYear
        this.vehicle = this.vindetails.vehicleLineDescription
        if (this.countrythree == 'ROM') {
          this.countrythree = 'ROU'
        }

        const newWindow = window.open(this.service.gtacUrl + 'LANG=' + this.lang + '-US&Contactid=&vin=' + this.Vinnumber + '&USERID=' + this.username + '&Symptom_codes=12&GEO=' + this.countrythree + '&PACODE=' + this.dealerCode + '&countryCode=' + this.countrythree + '&Model=' + this.vehicle + '&Year=' + this.modelYear, '_blank', 'width=700,height=700');
      })
    }
    else {
      this.modalService.open(content, {
        centered: true,
        backdrop: 'static', size: 'md'
      });
    }
  }

  ngOnDestroy() {
    this.startNWTStatus.unsubscribe();
    this.webSocketsubscription.unsubscribe();
    this.freshWebSocetSubscription.unsubscribe();
  }

  getDataCollectorCheckboxStatus(DataCollectorEvent: any) {
    this.service.dataCollectorInfo.next(DataCollectorEvent)
    this.dataCollectorEvent = DataCollectorEvent;
    console.log('------------Data Collector Event------------------', DataCollectorEvent);
  }

  //Whats New Changes
  protected hideWhatsNewBox() { this.showWhatsNew = false;         this.service.setShowWhatsNew(false);}


  initializeMessages() {
    const allEuropeanMarketsFromBackend: Market[] = this.europeanCountries.map(code => ({ id3: code, name: this.getCountryNameFromCode(code) }));

    const realMarkets = allEuropeanMarketsFromBackend
      .filter(market => this.europeanCountriesSet.has(market.id3))
      .sort((a: Market, b: Market) => a.name.localeCompare(b.name));

    this.availableMarkets = [{ id3: 'All', name: 'All' }, ...realMarkets];

    console.log('Available Markets for dropdown:', this.availableMarkets);

    this.predictInitialMarketAndLanguage();

    this.filterMessages();

    this.updateContainerClasses();
  }

  getCountryNameFromCode(code: string): string {
    const nameMap: { [key: string]: string } = {
      "ALB": "Albania", "AND": "Andorra", "ARM": "Armenia", "AUT": "Austria", "AZE": "Azerbaijan",
      "BLR": "Belarus", "BEL": "Belgium", "BIH": "Bosnia and Herzegovina", "BGR": "Bulgaria",
      "HRV": "Croatia", "CYP": "Cyprus", "CZE": "Czech Republic", "DNK": "Denmark", "EST": "Estonia",
      "FLK": "Falkland Islands (Malvinas)", "FIN": "Finland", "FRA": "France", "GEO": "Georgia",
      "DEU": "Germany", "GIB": "Gibraltar", "GRC": "Greece", "HUN": "Hungary", "ISL": "Iceland",
      "IRL": "Ireland", "ITA": "Italy", "KAZ": "Kazakhstan", "LVA": "Latvia", "LIE": "Liechtenstein",
      "LTU": "Lithuania", "LUX": "Luxembourg", "MKD": "North Macedonia", "MLT": "Malta",
      "MDA": "Moldova", "MCO": "Monaco", "MNE": "Montenegro", "NLD": "Netherlands", "NOR": "Norway",
      "POL": "Poland", "PRT": "Portugal", "ROU": "Romania", "RUS": "Russian Federation",
      "SMR": "San Marino", "SRB": "Serbia", "SVK": "Slovakia",
      "SVN": "Slovenia", "SGS": "South Georgia and the South Sandwich Islands", "ESP": "Spain",
      "SWE": "Sweden", "CHE": "Switzerland", "TUR": "Turkey", "UKR": "Ukraine", "GBR": "United Kingdom",
      "VAT": "Vatican City"
    };
    return nameMap[code] || code;
  }


  filterMessages() {
    let days = parseInt(this.selectedPeriod, 10);
    if (isNaN(days) || days <= 0) days = 90;

    const req = { market : this.selectedMarket, language : this.selectedLanguage, days : days };

    console.log('Filtering messages for Market:', this.selectedMarket, 'Language:', this.selectedLanguage, 'Days:', days);

    this.service.getWhatsNewMessage(req).subscribe(
      (response: BackendMessageResponse[]) => {
        console.log('Backend response for messages:', response);
        this.filteredMessages = response.map(msg => {
          let dateObj = msg.createdTime ? new Date(msg.createdTime) : new Date(0);
          let lastEditedDateObj = msg.updatedTime ? new Date(msg.updatedTime) : dateObj;

          if (isNaN(dateObj.getTime())) dateObj = new Date(0);
          if (isNaN(lastEditedDateObj.getTime())) lastEditedDateObj = dateObj;

          return {
            id: msg.id,
            type: msg.type,
            text: this.getDisplayHtml(msg.text ?? ''), // Ensure it's a string, then convert to HTML
            market: msg.market,
            language: msg.language,
            textColor: msg.textColor,
            date: dateObj,
            lastEditedDate: lastEditedDateObj,
            isNew: false,
            isHovered: false,
            isEditing: false,
            validationError: undefined,
            createdBy: msg.createdBy,
            updatedBy: msg.updatedBy,
            batchUuid: msg.batchUuid,
            isOriginallyAllBatch: msg.batchUuid != null && msg.batchUuid.trim() !== '',
            editable: msg.editable,
            isDisplayedAsBatch: undefined,
            representativeId: msg.id,
            attachmentFilename: msg.attachmentFilename,
            attachmentContentType: msg.attachmentContentType,
            originalFilename: msg.originalFilename
          } as Message;
        });
        this.processMessagesForDisplay();
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error("Error fetching What's New messages:", error);
        this.filteredMessages = [];
        this.displayedMessages = [];
        this.cdr.detectChanges();
      }
    );
  }

  processMessagesForDisplay(): void {
    this.displayedMessages = [];

    const groupedMessages = new Map<string | null, Message[]>();
    this.filteredMessages.forEach(message => {
      const key = (message.batchUuid && message.batchUuid.trim() !== '') ? message.batchUuid : 'SPECIFIC';
      if (!groupedMessages.has(key)) {
        groupedMessages.set(key, []);
      }
      groupedMessages.get(key)!.push(message);
    });

    groupedMessages.forEach((group, key) => {
      if (key === 'SPECIFIC') {
        group.forEach(message => {
          this.displayedMessages.push({
            ...message,
            isDisplayedAsBatch: false,
            isOriginallyAllBatch: false,
            representativeId: message.id
          });
        });
      } else {
        if (this.selectedMarket && this.selectedMarket.toLowerCase() === "all") {
          const allMarketMessage = group.find(msg => msg.market.toLowerCase() === 'all');

          const representativeMessage = allMarketMessage
            ? allMarketMessage
            : group.reduce((prev, current) => (prev.lastEditedDate > current.lastEditedDate) ? prev : current);

          const consolidatedMessage: Message = {
            ...representativeMessage,
            market: 'All',
            isDisplayedAsBatch: true,
            representativeId: representativeMessage.id,
            isEditing: false,
            isHovered: false,
            validationError: undefined
          };
          this.displayedMessages.push(consolidatedMessage);

        } else {
          group.forEach(message => {
            this.displayedMessages.push({
              ...message,
              isDisplayedAsBatch: false,
              representativeId: message.id
            });
          });
        }
      }
    });

    this.checkNewMessages();
  }


  selectPeriod() { this.filterMessages(); }

  checkNewMessages() {
    const cutoffDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    this.displayedMessages.forEach(message => {
      message.isNew = message.lastEditedDate instanceof Date && !isNaN(message.lastEditedDate.getTime()) && message.lastEditedDate >= cutoffDate;
    });
    this.sortMessages();
  }

  sortMessages(): void {
    this.displayedMessages.sort((a, b) => b.lastEditedDate.getTime() - a.lastEditedDate.getTime());
  }

  onMarketChange(selectedCountryId3: string) {
    this.selectedMarket = selectedCountryId3;
    this.filterMessages();
  }

  onLanguageChange(selectedLanguage: string) {
    this.selectedLanguage = selectedLanguage;
    this.filterMessages();
  }


  private predictInitialMarketAndLanguage(): void {
    let predictedMarketId3: string = 'All';
    let predictedLanguage: string = 'English';

    const userCountryThree = this.market;
    const userLangCode = this.lang;

    console.log(`Attempting initial prediction for user country three: ${userCountryThree}, user language code: ${userLangCode}`);

    if (userCountryThree && this.europeanCountriesSet.has(userCountryThree.toUpperCase())) {
      predictedMarketId3 = userCountryThree;
      console.log(`User country three (${userCountryThree}) found in European list. Predicted market: ${predictedMarketId3}`);
    } else {
      console.log(`User country three (${userCountryThree}) not found in European list or is missing. Defaulting to 'All'.`);
    }

    if (userLangCode) {
      const normalizedUserLangCode = userLangCode.toLowerCase().split('-')[0];
      console.log(`Normalized user language code: ${normalizedUserLangCode}`);

      const matchedLanguage = this.languageCodeMap[normalizedUserLangCode];

      if (matchedLanguage && this.availableLanguages.includes(matchedLanguage)) {
        predictedLanguage = matchedLanguage;
        console.log(`Matched token language code (${userLangCode}) to available language: ${predictedLanguage}`);
      } else {
        console.log(`Token language code (${userLangCode}) did not match an available language name or is not in availableLanguages list. Defaulting to 'English'.`);
        predictedLanguage = 'English';
      }
    } else {
      console.log('User language code (lang) is missing from token. Defaulting to \'English\'.');
      predictedLanguage = 'English';
    }

    this.selectedMarket = predictedMarketId3;
    this.selectedLanguage = predictedLanguage;

    console.log(`Final initial prediction results: selectedMarket = ${this.selectedMarket}, selectedLanguage = ${this.selectedLanguage}`);

    this.cdr.detectChanges();
  }


  formatMarketName(name: string): string {
    if (!name) return '';
    return name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  getColorName(hexCode?: string): string {
    if (!hexCode) return 'Default';
    const upperHex = hexCode.toUpperCase();
    return this.colorNameMap[upperHex] || upperHex;
  }

  onFileSelected(event: any, formType: 'add' | 'edit') {
    const file: File = event.target.files && event.target.files.length > 0 ? event.target.files[0] : null;
    this.fileValidationError = null;

    if (file) {
      const allowedTypes = ['application/pdf'];
      const maxFileSize = 5 * 1024 * 1024;

      if (!allowedTypes.includes(file.type)) {
        this.fileValidationError = 'Only PDF files are allowed.';
        if (formType === 'add') { this.selectedFileForAdd = null; this.selectedFilenameForAdd = null; }
        else { this.selectedFileForEdit = null; this.selectedFilenameForEdit = null; this.removeExistingAttachment = false; }
        if (event.target) event.target.value = '';
        return;
      }

      if (file.size > maxFileSize) {
        this.fileValidationError = `File size exceeds limit (${maxFileSize / (1024*1024)}MB).`;
        if (formType === 'add') { this.selectedFileForAdd = null; this.selectedFilenameForAdd = null; }
        else { this.selectedFileForEdit = null; this.selectedFilenameForEdit = null; this.removeExistingAttachment = false; }
        if (event.target) event.target.value = '';
        return;
      }

      if (formType === 'add') {
        this.selectedFileForAdd = file;
        this.selectedFilenameForAdd = file.name;
      } else {
        this.selectedFileForEdit = file;
        this.selectedFilenameForEdit = file.name;
        this.removeExistingAttachment = false;
      }
    } else {
      if (formType === 'edit' && event.target) {
        this.selectedFileForEdit = null;
        this.selectedFilenameForEdit = this.currentEditingMessage?.originalFilename || null;
      }
    }
    this.cdr.detectChanges();
  }

  removeAttachment() {
    this.selectedFileForEdit = null;
    this.selectedFilenameForEdit = null;
    this.removeExistingAttachment = true;
    this.fileValidationError = null;
    if (this.editingMessageData) {
      this.editingMessageData.attachmentFilename = undefined;
      this.editingMessageData.attachmentContentType = undefined;
      this.editingMessageData.originalFilename = undefined;
      this.editingMessageData.removeAttachment = true;
    }
    this.cdr.detectChanges();
  }

  getAttachmentUrl(filename: string | undefined): string {
    if (!filename) return '#';
    return `/sbdo/whats-new/attachments/${filename}`;
  }

  getPdfIconPath(): string {
    return 'assets/images/pdf-icon.png';
  }


  showNewMessageInput() {
    if (!this.superAdmin || this.isAddingNewMessage || this.showEditForm) return;

    this.isAddingNewMessage = true;
    this.newMessageHeader = '';
    this.newMessageText = '';
    this.newMessageColor = '#000000';
    this.selectedFileForAdd = null;
    this.selectedFilenameForAdd = null;
    this.addValidationError = null;
    this.editValidationError = null;
    this.fileValidationError = null;
    this.updateContainerClasses();
    this.updateNewMessageCharCount();
  }

  cancelAddMessage() {
    this.isAddingNewMessage = false;
    this.newMessageText = '';
    this.newMessageHeader = '';
    this.newMessageColor = '#000000';
    this.selectedFileForAdd = null;
    this.selectedFilenameForAdd = null;
    this.addValidationError = null;
    this.fileValidationError = null;
    this.updateContainerClasses();
    this.updateNewMessageCharCount();

  }

  private cleanQuillHtmlOnSave(html: string): string {
    if (!html) return '';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Only remove the very last paragraph if it's effectively empty.
    // Quill often adds an extraneous <p><br></p> or <p></p> at the end.
    if (tempDiv.lastElementChild && tempDiv.lastElementChild.tagName.toLowerCase() === 'p') {
      const lastP = tempDiv.lastElementChild;
      const innerHTML = lastP.innerHTML.toLowerCase().trim();
      const textContent = lastP.textContent?.trim() || '';

      // Check if the last paragraph is truly empty (contains no visible text or just a <br>)
      const isEffectivelyEmpty = (textContent === '' && (innerHTML === '' || innerHTML === '<br>' || innerHTML === '&nbsp;'));

      if (isEffectivelyEmpty) {
        lastP.remove();
      }
    }
    // All other blank lines (multiple <p><br></p> in a row) will now be preserved.
    return tempDiv.innerHTML;
  }

  addMessage() {
    const trimmedHeader = this.newMessageHeader ? this.newMessageHeader.trim() : '';

    // Clean the HTML from Quill before any further processing or sending
    let cleanedHtml = this.cleanQuillHtmlOnSave(this.newMessageText);

    // Use a temporary div to get plain text length from the cleaned HTML
    const tempDivForPlainText = document.createElement('div');
    tempDivForPlainText.innerHTML = cleanedHtml;
    const plainTextContent = tempDivForPlainText.textContent?.length || 0;


    if (!trimmedHeader) { this.addValidationError = 'Message title cannot be empty.'; this.cdr.detectChanges(); return; }
    if (plainTextContent === 0) { this.addValidationError = 'Message body cannot be empty.'; this.cdr.detectChanges(); return; }
    if (this.fileValidationError) {
      this.cdr.detectChanges();
      return;
    }

    this.addValidationError = null;

    const messageData: WhatsNewMessageRequest = {
      type: trimmedHeader,
      text: cleanedHtml, // Send the cleaned HTML to the backend
      market: this.selectedMarket === 'All' ? 'All' : this.selectedMarket,
      language: this.selectedLanguage,
      textColor: this.newMessageColor,
      createdBy: this.username || 'Unknown',
      updatedBy: this.username || 'Unknown',
    };

    this.service.addMessage(messageData, this.selectedFileForAdd).subscribe(
      (savedMessagesResponse: BackendMessageResponse[]) => {
        console.log('Message saved:', savedMessagesResponse);
        this.filterMessages();
        this.newMessageText = '';
        this.newMessageHeader = '';
        this.newMessageColor = '#000000';
        this.selectedFileForAdd = null;
        this.selectedFilenameForAdd = null;
        this.isAddingNewMessage = false;
        this.addValidationError = null;
        this.fileValidationError = null;
        this.updateContainerClasses();
        this.isMessageSaved = true;
        this.updateNewMessageCharCount();
        this.cdr.detectChanges();
        setTimeout(() => { this.isMessageSaved = false; this.cdr.detectChanges(); }, 2000);
      },
      (error: any) => {
        console.error("Error saving new message:", error);
        let errorMessage = 'Failed to save message. Please try again.';
        if (error.error?.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.addValidationError = errorMessage;
        this.fileValidationError = null;
        this.cdr.detectChanges();
      }
    );
  }

  // Store the Quill editor instance for the edit form
  private editQuillEditorInstance: any;

  // New method to handle the onEditorCreated event for the edit form
  onEditEditorCreated(editor: any) {
    this.editQuillEditorInstance = editor;
    // Log for debugging
    console.log('onEditEditorCreated fired. currentEditingMessage:', this.currentEditingMessage);
    console.log('onEditEditorCreated fired. editingMessageData:', this.editingMessageData);


    // Only load content if currentEditingMessage is set (i.e., we are in edit mode)
    // and if editingMessageData is set.
    if (this.currentEditingMessage && this.editingMessageData) {
      // Use rawEditingMessageText — the original backend HTML with ql-ui spans stripped.
      // Do NOT use editingMessageData.text here: Angular's ngModel write path may have
      // already normalised list HTML into plain <p> tags by the time this fires.
      console.log('onEditEditorCreated: rawEditingMessageText =', this.rawEditingMessageText);
      this._loadContentIntoEditor(editor, this.rawEditingMessageText);
    }
  }

  // Helper method to load content into Quill editor
  /**
   * Strips Quill v2's internal <span class="ql-ui"> elements from the HTML before
   * passing it to dangerouslyPasteHTML. Quill re-creates these spans itself when it
   * renders list items — if they are already present in the pasted HTML, Quill ends up
   * with duplicate/conflicting ql-ui spans and the bullet markers do not render correctly.
   * The data-list="bullet" attribute on <li> elements is preserved so Quill still knows
   * each item is a bullet-list entry.
   */
  private _stripQuillUiSpans(html: string): string {
    if (!html) return html;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    // Remove every <span class="ql-ui"> — Quill will re-insert them when it renders
    Array.from(tempDiv.querySelectorAll('span.ql-ui')).forEach(span => span.remove());
    return tempDiv.innerHTML;
  }

  private _loadContentIntoEditor(editor: any, htmlContent: string) {
    if (!editor) {
      console.warn('_loadContentIntoEditor: Editor instance is not available.');
      return;
    }

    // Set the flag to true before programmatic changes
    this.isLoadingEditorContent = true;

    // Clear any existing content in the editor to ensure a clean slate
    editor.deleteText(0, editor.getLength());

    const pasteHtml = this._stripQuillUiSpans(htmlContent);

    // Paste the HTML content into the editor
    editor.clipboard.dangerouslyPasteHTML(0, pasteHtml);

    // CRITICAL: After dangerouslyPasteHTML, immediately synchronize the ngModel-bound variable
    // (`editingMessageData.text`) with Quill's actual internal HTML representation.
    // This is crucial because Quill might normalize HTML (e.g., `<b>` to `strong`), or add/remove <p> tags,
    // and `ngModel` needs to reflect Quill's final, processed state for subsequent user edits
    // and to prevent content from being overwritten if `ngModel` re-evaluates.
    // This also ensures that when onEditMessageContentChanged is naturally called by Quill,
    // editingMessageData.text already holds the correct, normalized HTML.
    if (this.editingMessageData) { // Null check for safety
      this.editingMessageData.text = editor.root.innerHTML;
    }

    // Update character counts.
    // Quill's onContentChanged will handle updating editingMessageData.text.
    // We only update the character remaining here.
    const currentTextLength = editor.getText().length - 1; // Subtract 1 for trailing newline
    this.editMessagesCharRemaining = this.maxUserCharacters - currentTextLength;
    if (this.editMessagesCharRemaining < 0) {
      this.editMessagesCharRemaining = 0;
    }

    // Set the flag back to false after programmatic changes are complete.
    // Use a generous setTimeout to ensure ALL Quill-triggered content-change events
    // from dangerouslyPasteHTML have fired and been ignored before we allow
    // onEditMessageContentChanged to write back to editingMessageData.text again.
    setTimeout(() => {
      // Sync the model one final time from the editor's actual DOM state,
      // now that Quill has fully settled (including re-creating ql-ui spans etc.).
      if (this.editingMessageData) {
        this.editingMessageData.text = editor.root.innerHTML;
      }
      this.isLoadingEditorContent = false;
      this.cdr.detectChanges(); // Re-trigger detection to ensure UI is updated after flag change
    }, 300); // A small delay to allow Quill's internal events to settle. Adjust if necessary.


    // Force another change detection cycle. This helps ensure that the UI (like character counts)
    // updates correctly after the content has been fully loaded and synchronized.
    this.cdr.detectChanges();
  }


  editMessage(message: Message) {
    if (!this.superAdmin || this.isAddingNewMessage || this.showEditForm) return;

    if (!message.editable) {
      console.warn("Attempted to edit a message that is not editable in this view:", message);
      return;
    }

    this.currentEditingMessage = message; // Set the source of truth for the content

    // Store the raw backend HTML (with <ol><li data-list="bullet">) for use by
    // onEditEditorCreated → dangerouslyPasteHTML. We strip only the ql-ui spans here
    // so Quill can re-create them cleanly when it renders the list items.
    // NOTE: We do NOT put this into editingMessageData.text because Angular's ngModel
    // write path normalises <ol><li data-list="bullet"> into plain <p> tags, destroying
    // the bullet structure before it even reaches the editor DOM.
    this.rawEditingMessageText = this._stripQuillUiSpans(message.text);

    this.isLoadingEditorContent = true; // Set flag early

    this.editingMessageData = {
      type: message.type,
      text: '',   // Start empty — editor is populated via dangerouslyPasteHTML only
      market: message.market,
      language: message.language,
      textColor: message.textColor ?? '#000000',
      createdBy: message.createdBy ?? 'Unknown',
      updatedBy: this.username || 'Unknown',

      attachmentFilename: message.attachmentFilename,
      attachmentContentType: message.attachmentContentType,
      originalFilename: message.originalFilename,
      removeAttachment: false
    };

    this.selectedFileForEdit = null;
    this.selectedFilenameForEdit = message.originalFilename || null;
    this.removeExistingAttachment = false;
    this.fileValidationError = null;

    message.isEditing = true;
    message.isHovered = false;
    this.showEditForm = true;
    this.editValidationError = null;
    this.updateContainerClasses();
    this.updateEditMessageCharCount();
    this.cdr.detectChanges();

    // Fallback: if onEditEditorCreated already fired before showEditForm triggered a re-render,
    // load content directly now. rawEditingMessageText holds the ql-ui-stripped backend HTML.
    setTimeout(() => {
      if (this.editQuillEditorRef && this.editQuillEditorRef.quillEditor && this.currentEditingMessage) {
        this._loadContentIntoEditor(this.editQuillEditorRef.quillEditor, this.rawEditingMessageText);
      }
    }, 50); // Small delay for robustness
  }


  onSaveMessageClicked(displayedMessage: Message) {
    if (!this.editingMessageData || !displayedMessage) {
      console.error("Save clicked but no editing data or displayed message.", {editingData: this.editingMessageData, displayedMsg: displayedMessage});
      if(displayedMessage) this.cancelEdit(displayedMessage);
      else this.cancelEdit({} as Message);
      return;
    }

    const trimmedHeader = this.editingMessageData.type ? this.editingMessageData.type.trim() : '';

    // Get HTML directly from the Quill editor DOM as the authoritative source.
    // editingMessageData.text starts as '' and is populated async (300ms after load),
    // so always read from the live editor to avoid saving empty content.
    const editorHtml = (this.editQuillEditorRef && this.editQuillEditorRef.quillEditor)
      ? this.editQuillEditorRef.quillEditor.root.innerHTML
      : this.editingMessageData.text;

    let cleanedHtml = this.cleanQuillHtmlOnSave(editorHtml);

    const tempDiv = document.createElement('div'); // Use a temporary div to get plain text from HTML
    tempDiv.innerHTML = cleanedHtml;
    const plainTextContent = tempDiv.textContent?.length || 0;


    if (!trimmedHeader) { this.editValidationError = 'Message title cannot be empty.'; this.cdr.detectChanges(); return; }
    if (plainTextContent === 0) { this.editValidationError = 'Message body cannot be empty.'; this.cdr.detectChanges(); return; }
    if (this.fileValidationError) {
      this.cdr.detectChanges();
      return;
    }

    this.editValidationError = null;

    const idToSend = displayedMessage.id;

    if (idToSend === undefined || idToSend === null || idToSend < 0) {
      console.error("Invalid ID determined for update:", idToSend, {displayedMessage});
      this.cancelEdit(displayedMessage);
      return;
    }

    const messageData: WhatsNewMessageRequest = {
      type: trimmedHeader,
      text: cleanedHtml, // Send HTML content from Quill (guaranteed string)
      market: displayedMessage.market,
      language: displayedMessage.language,
      textColor: this.editingMessageData.textColor || '#000000',
      createdBy: displayedMessage.createdBy || 'Unknown',
      updatedBy: this.username || 'Unknown',

      attachmentFilename: this.editingMessageData.attachmentFilename,
      attachmentContentType: this.editingMessageData.attachmentContentType,
      originalFilename: this.editingMessageData.originalFilename,
      removeAttachment: this.removeExistingAttachment
    };

    this.service.updateMessage(idToSend, messageData, this.selectedMarket, this.selectedFileForEdit).subscribe(
      (updatedMessageResponse: BackendMessageResponse) => {
        console.log('Message updated:', updatedMessageResponse);
        this.filterMessages();
        this.isMessageSaved = true;
        displayedMessage.isEditing = false;
        this.currentEditingMessage = null;
        this.editingMessageData = null;
        this.showEditForm = false;
        this.editValidationError = null;
        this.selectedFileForEdit = null;
        this.selectedFilenameForEdit = null;
        this.removeExistingAttachment = false;
        this.fileValidationError = null;
        this.updateContainerClasses();
        this.updateEditMessageCharCount();
        this.cdr.detectChanges();
        setTimeout(() => { this.isMessageSaved = false; this.cdr.detectChanges(); }, 2000);
      },
      (error: any) => {
        console.error("Error updating message:", error);
        let errorMessage = 'Failed to update message. Please try again.';
        if (error.error?.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.editValidationError = errorMessage;
        this.fileValidationError = null;
        this.cdr.detectChanges();
      }
    );
  }


  cancelEdit(displayedMessage: Message) {
    if (!displayedMessage) {
      console.warn("Cancel edit called without a valid message.");
      this.currentEditingMessage = null;
      this.editingMessageData = null;
      this.showEditForm = false;
      this.editValidationError = null;
      this.selectedFileForEdit = null;
      this.selectedFilenameForEdit = null;
      this.removeExistingAttachment = false;
      this.fileValidationError = null;
      this.updateContainerClasses();
      this.updateEditMessageCharCount();
      this.cdr.detectChanges();
      return;
    }

    const messageInList = this.displayedMessages.find(m => m.id === displayedMessage.id);
    if (messageInList) {
      messageInList.isEditing = false;
      messageInList.isHovered = false;
      messageInList.validationError = undefined;
    }

    this.currentEditingMessage = null;
    this.editingMessageData = null;
    this.showEditForm = false;
    this.editValidationError = null;
    this.selectedFileForEdit = null;
    this.selectedFilenameForEdit = null;
    this.removeExistingAttachment = false;
    this.fileValidationError = null;

    this.filterMessages();

    this.updateContainerClasses();
    this.cdr.detectChanges();
  }

  deleteMessage(displayedMessageId: number) {
    if (!this.superAdmin || this.isAddingNewMessage || this.showEditForm) return;

    const messageToDelete = this.displayedMessages.find(m => m.id === displayedMessageId);

    if (!messageToDelete) {
      console.error("Could not find displayed message with ID for deletion:", displayedMessageId);
      return;
    }

    if (!messageToDelete.editable) {
      console.warn("Attempted to delete a message that is not deletable in this view:", messageToDelete);
      return;
    }

    const realIdToDelete = messageToDelete.id;

    if (realIdToDelete === undefined || realIdToDelete === null || realIdToDelete < 0) {
      console.error("Invalid ID determined for deletion:", realIdToDelete, {displayedMessage: messageToDelete});
      return;
    }

    this.messageIdToDelete = realIdToDelete;

    if (this.deleteWhatsNew) {
      this.modalService.open(this.deleteWhatsNew, { size: 'md' });
      this.cdr.detectChanges();
    } else {
      console.error("Delete confirmation modal template not found.");
    }
  }

  confirmDeleteMessage() {
    if (this.messageIdToDelete === undefined || this.messageIdToDelete === null || this.messageIdToDelete < 0) {
      console.error("Confirm delete clicked but no valid messageIdToDelete:", this.messageIdToDelete);
      this.modalService.dismissAll();
      return;
    }

    const idToDelete = this.messageIdToDelete;
    this.messageIdToDelete = 0;

    this.service.deleteWhatsNewMessage(idToDelete, this.selectedMarket).subscribe(
      (response: any) => {
        console.log('Message(s) deleted successfully.');
        this.filterMessages();
        this.isMessageDeleted = true;
        this.cdr.detectChanges();
        setTimeout(() => { this.isMessageDeleted = false; this.cdr.detectChanges(); }, 2000);
        this.modalService.dismissAll();
      },
      (error: { error: { message: string; }; message: string; }) => {
        console.error("Error deleting message:", error);
        let errorMessage = 'Failed to delete message. Please try again.';
        if (error.error?.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        console.error("Deletion error message:", errorMessage);
        this.modalService.dismissAll();
        this.cdr.detectChanges();
      }
    );
  }

  getSortedMessages(): Message[] {
    return this.displayedMessages;
  }

  getNewIconPath(): string {
    return this.languageIconMap[this.selectedLanguage] || 'assets/images/new-icon.png';
  }

  getNonEmptyLines(text: string | undefined): string[] {
    if (!text) return [];
    return text.split('\n').filter(line => line.trim().length > 0);
  }

  /**
   * Generates HTML for message display and for loading into Quill editor.
   * This function is crucial for ensuring that all incoming text (whether plain or partially HTML)
   * is converted into well-formed HTML that Quill can parse and display correctly.
   *
   * Rules:
   * 1. If text contains HTML tags, assume it's valid HTML and return as is. This preserves Quill's rich text.
   * 2. If text is plain (no HTML tags), wrap each non-empty line in <p> tags.
   * 3. Special handling for bare <li> tags if they exist directly under <body> (legacy data).
   */
  getDisplayHtml(text: string): string {
    if (!text) return '';

    // Check if the text already contains HTML tags (a more general check)
    const containsHtmlTags = /<[a-z][\s\S]*>/i.test(text);

    if (containsHtmlTags) {
      // If it contains HTML, assume it's valid HTML from Quill and return it as is.
      // The backend's Jsoup.clean should have already sanitized it.
      return text;
    } else {
      // If it's plain text (e.g., legacy data or simple input without formatting),
      // convert newlines to paragraphs and preserve all spaces.
      const lines = text.split('\n');
      return lines.map(line => {
        // DO NOT TRIM HERE to preserve leading/trailing spaces in plain text
        return line ? `<p>${line}</p>` : '<p><br></p>'; // Preserve empty lines and all spaces within them
      }).join('');
    }
  }

  downloadAttachment(filename: string | undefined, originalFilename: string | undefined): void {
    if (!filename) {
      console.warn("Attempted to download attachment with no filename.");
      return;
    }

    console.log(`Attempting to download attachment: ${filename} (Original: ${originalFilename})`);

    // Call the service method that fetches the Blob
    this.service.getWhatsNewAttachment(filename).subscribe(
      (blob: Blob) => {
        console.log("Received blob from service, attempting to download.");
        // Create a temporary URL for the blob
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        // Set the download filename using the original filename if available
        a.download = originalFilename || filename;
        document.body.appendChild(a); // Append to trigger download
        a.click(); // Trigger the download
        document.body.removeChild(a); // Clean up the element
        window.URL.revokeObjectURL(blobUrl); // Release the temporary URL
        console.log("Download initiated.");
      },
      (error: any) => {
        console.error("Error downloading attachment:", error);
        // Optionally show an error message to the user
        alert("Failed to download attachment. Please try again.");
      }
    );
  }

  private updateContainerClasses() {
    setTimeout(() => {
      if (this.whatsNewContainer && this.whatsNewContainer.nativeElement) {
        const container = this.whatsNewContainer.nativeElement;
        if (this.isAddingNewMessage) {
          this.renderer.addClass(container, 'adding-message');
        } else {
          this.renderer.removeClass(container, 'adding-message');
        }
        if (this.showEditForm) {
          this.renderer.addClass(container, 'editing-message');
        } else {
          this.renderer.removeClass(container, 'editing-message');
        }
        if (this.superAdmin) {
          this.renderer.addClass(container, 'admin-mode');
        } else {
          this.renderer.removeClass(container, 'admin-mode');
        }
      }
    }, 0);
  }

  openGtacPreCheck(preCheckTemplate: any) {
    this.isTemplateDownloaded = false;
    this.isTemplateCompleteChecked = false;

    this.preCheckModalRef = this.modalService.open(preCheckTemplate, {
      centered: true,
      backdrop: 'static',
      size: 'md'
    });
  }

  downloadForm(type: 'pdf' | 'docx'): void {
    this.service.downloadActiveTemplate(type).subscribe(
      (response: HttpResponse<Blob>) => {
        const blob = response.body;
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `gtac_template.${type === 'docx' ? 'docx' : 'pdf'}`;

        if (contentDisposition) {
          const filenameRegex = /filename\*?=['"]?(?:UTF-8''|encoding'')?([^;"]+)['"]?;?/i; [1, 2]
          const matches = filenameRegex.exec(contentDisposition); [1, 2]
          if (matches != null && matches[1]) {
            try {
              // Decode URI component to handle URL-encoded filenames (e.g., spaces as %20)
              filename = decodeURIComponent(matches[1].replace(/\+/g, ' '));
            } catch (e) {
              console.warn('Could not decode filename from Content-Disposition, using raw value.', e);
              filename = matches[1];
            }
          }
        }

        if (blob) {
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          a.href = objectUrl;
          a.download = filename; // Use the extracted filename
          a.click();
          URL.revokeObjectURL(objectUrl);
          this.isTemplateDownloaded = true;
        } else {
          console.error('Download failed: Blob is null or undefined.');
        }
      },
      (error: any) => {
        console.error('Download failed:', error);
      }
    );
  }

continueToGtac(content: any){
    this.preCheckModalRef.close();
    this.contactSubmit(content)
  }
detectBrowser(userAgent: string): string {
  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) return 'Chrome';
  if (userAgent.includes('Firefox')) return 'Firefox';
  if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari';
  if (userAgent.includes('Edg')) return 'Edge';
  if (userAgent.includes('Opera') || userAgent.includes('OPR')) return 'Opera';
  return 'Unknown';
}

closeModal(reason: string) {
  this.modalService.dismissAll(reason);
}
  switchBrowser(reason: string) {
    window.top?.postMessage({type:'NAVIGATE_PARENT',url: this.ptsUrl + 'Home/Index'},'*');
  }

}
